import { render, staticRenderFns } from "./Organism.vue?vue&type=template&id=c325c37e&scoped=true&"
import script from "./Organism.vue?vue&type=script&lang=js&"
export * from "./Organism.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c325c37e",
  null
  
)

export default component.exports